import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';

type breakPoints = 'sm' | 'md' | 'lg' | 'xl' | '2xl';
const bp: Record<breakPoints, number> = {
  sm: 490,
  md: 768,
  lg: 935,
  xl: 1280,
  '2xl': 1536,
};

export const getDeviceConfig = (width: number): breakPoints => {
  switch (true) {
    case width < 490:
      return 'sm';
    case width >= bp.sm && width < bp.md:
      return 'md';
    case width >= bp.md && width < bp.lg:
      return 'lg';
    case width >= bp.lg:
    default:
      return 'xl';
  }
};

const useBreakpoint = (): {
  brkPnt: breakPoints;
  isBigScreen: boolean;
  isSmallScreen: boolean;
} => {
  const [brkPnt, setBrkPnt] = useState<breakPoints>(() =>
    getDeviceConfig(window.innerWidth),
  );

  useEffect(() => {
    const calcInnerWidth = throttle(function () {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return {
    brkPnt,
    isBigScreen: brkPnt === 'xl' || brkPnt === 'lg' || brkPnt === '2xl',
    isSmallScreen: brkPnt === 'md' || brkPnt === 'sm',
  };
};
export default useBreakpoint;
